module.exports = __webpack_public_path__ + "static/curvyLines-3a1df6c1e0644b8b1a12219346c3f013.png";